import Image from "next/image";
import Link from "next/link";

const Footer_Second_Section = ({footerSecondSection, footerSecondMenu, footerThirdSection, footerThirdMenu, footerFourthSection}) =>{
    return(
        <div className="w-full lg:w-[62%]">
              <div className="sm:grid sm:grid-cols-2 md:grid-cols-3">
                <div>
                  {footerSecondSection?.title && <h4 className="mb-4 lg:mb-[2vw] text-lg lg:text-[1.25vw]  text-white">
                    {footerSecondSection.title}
                  </h4>}
                  {footerSecondMenu && <ul className="*:mb-2  *:lg:mb-[1vw]">
                    {footerSecondMenu?.map((item, index) => (
                      <li key={index}>
                        <Link
                          href={
                            item.slug.includes("https") ||
                              item.slug.includes("http")
                              ? item.slug || "#"
                              : (item.slug || "#")
                          }
                          target={
                            item.slug.includes("https") ||
                              item.slug.includes("http")
                              ? "_blank"
                              : undefined
                          }
                          className="hover:text-white hover:tracking-wide transition-all"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>}
                </div>
                <div>
                  {footerThirdSection?.title && <h4 className="mb-4 lg:mb-[2vw] text-lg lg:text-[1.25vw]  text-white">
                    {footerThirdSection.title}
                  </h4>}
                  {footerThirdMenu && <ul className="*:mb-2  *:lg:mb-[1vw]">
                    {footerThirdMenu?.map((item, index) => (
                      <li key={index}>
                        <Link
                          href={item.slug || "#"}
                          className="hover:text-white hover:tracking-wide transition-all"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>}
                </div>
                <div className="col-span-2 sm:col-auto	">
                  {footerFourthSection?.title && <h4 className="mb-4 lg:mb-[2vw] text-lg lg:text-[1.25vw]  text-white">
                    {footerFourthSection.title}
                  </h4>}
                  {footerFourthSection?.address && <p>{footerFourthSection.address}</p>}

                  {footerFourthSection && <ul className="mt-4 lg:mt-[2vw] *:mb-4 *:lg:mb-[1vw]">
                    {footerFourthSection?.phone && <li className="flex gap-x-4 lg:gap-x-[1vw]">
                      <Image
                        width={20}
                        height={20}
                        src={"/images/call.svg"}
                        className="footerIcon"
                        loading="lazy"
                        alt=""
                      />{" "}
                      Toll Free: {footerFourthSection.phone}
                    </li>}
                    {footerFourthSection?.whatsapp && <li>
                      <Link
                        href={`https://wa.me/${footerFourthSection.whatsapp}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-x-4 lg:gap-x-[1vw]"
                      >
                        <Image
                          width={20}
                          height={20}
                          src={"/images/whatsapp.svg"}
                          className="footerIcon"
                          alt="WhatsApp"
                          loading="lazy"
                        />
                        {footerFourthSection.whatsapp}
                      </Link>
                    </li>}

                    {footerFourthSection?.email && <li className="flex gap-x-4 lg:gap-x-[1vw]">
                      <Image
                        width={20}
                        height={20}
                        src={"/images/mail.svg"}
                        className="footerIcon"
                        loading="lazy"
                        alt=""
                      />{" "}
                      {footerFourthSection.email}
                    </li>}
                    {footerFourthSection?.more_info && <li className="flex gap-x-4 lg:gap-x-[1vw]">
                      <Image
                        width={20}
                        height={20}
                        src={"/images/link.svg"}
                        className="footerIcon"
                        loading="lazy"
                        alt=""
                      />{" "}
                      {footerFourthSection.more_info}
                    </li>}
                  </ul>}
                </div>
              </div>
            </div>
    )
}

export default Footer_Second_Section;